export enum ReviseType {
  MANUAL = 'MANUAL',
  TEMPLATE = 'TEMPLATE'
}
